<!-- Unified Dashboard Template -->
@if (isAdmin()) {
  <!-- Admin Dashboard -->
  <app-admin-dashboard></app-admin-dashboard>
} @else if (isDoctorOrNurse()) {
  <!-- Medical Dashboard -->
  <app-dashboard></app-dashboard>
} @else {
  <!-- Fallback content for unknown roles -->
  <div class="min-h-screen bg-gray-100 flex items-center justify-center">
    <div class="text-center">
      <h2 class="text-2xl font-bold text-gray-900 mb-4">
        {{ translationService.translate('dashboard.accessDenied') }}
      </h2>
      <p class="text-gray-600">{{ translationService.translate('dashboard.roleNotRecognized') }}</p>
    </div>
  </div>
}
